import React, { useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  FormContext,
  FormLocalDateTimeField,
  FormSubmitButton,
} from '@eas/common-web';
import { FormattedMessage } from 'react-intl';
import { FormImportField } from '@components/form-import-field/form-import-field';
import { useLastSync } from './mpt-api';

const useStyles = makeStyles({
  header: {
    textAlign: 'left',
    marginBottom: 30,
    fontSize: 16,
    fontWeight: 500,
  },
});

export function MptFields({
  editing,
  loading,
  handleStartEditing,
  handleCancelEditing,
  handleCancelLoading,
}: {
  editing: boolean;
  loading: boolean;
  handleStartEditing: () => void;
  handleCancelEditing: () => void;
  handleCancelLoading: () => void;
}) {
  const [timestamp] = useLastSync();

  const { setFieldValue, getFieldValues } = useContext(FormContext);
  const formTimestamp = getFieldValues().timestamp;

  const classes = useStyles();

  useEffect(() => {
    if (!formTimestamp && timestamp) setFieldValue('timestamp', timestamp);
  }, [timestamp, formTimestamp, setFieldValue]);

  return (
    <>
      <Typography variant="h5" className={classes.header}>
        <FormattedMessage
          id="ES__APP_SETTINGS__PANEL_TITLE"
          defaultMessage="Nahrávání souborů může trvat několik minut."
        />
      </Typography>

      <FormImportField
        name="fileCz"
        label={
          <FormattedMessage
            id="TAPIS__MPT_IMPORT_FILE_CZ"
            defaultMessage="MPT třídník - CZ"
          />
        }
        acceptedFormats={['.xml']}
      />
      {
        // English import field will be used in the future
      }
      {/*      <FormImportField
        name="fileEn"
        label={
          <FormattedMessage
            id="TAPIS__MPT_IMPORT_FILE_EN"
            defaultMessage="MPT třídník - AJ"
          />
        }
      /> */}
      <FormImportField
        name="fileImages"
        label={
          <FormattedMessage
            id="TAPIS__MPT_IMPORT_FILE_IMAGES"
            defaultMessage="Soubory MPT třídníku"
          />
        }
        acceptedFormats={['.zip']}
      />

      <FormLocalDateTimeField
        label={
          <FormattedMessage
            id="TAPIS__MPT_IMPORT_FILE_IMAGES"
            defaultMessage="Poslední synchronizace"
          />
        }
        name="timestamp"
        disabled
      />

      <Grid container>
        <Grid item xs={12} sm={12}>
          <Box height={50} />
          <Box display="flex" flexDirection="row-reverse">
            {editing || loading ? (
              <>
                <Button
                  variant="contained"
                  // disabled={loading}
                  onClick={() => {
                    loading ? handleCancelLoading() : handleCancelEditing();
                  }}
                >
                  <FormattedMessage
                    id="ES__APP_SETTINGS__BTN_CANCEL"
                    defaultMessage="Zrušit"
                  />
                </Button>
                <Box width={10} />
                <FormSubmitButton
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  startIcon={
                    loading && <CircularProgress size="20px" color="inherit" />
                  }
                >
                  {loading ? (
                    <FormattedMessage
                      id="ES__APP_SETTINGS__BTN_SAVING"
                      defaultMessage="Ukládání"
                    />
                  ) : (
                    <FormattedMessage
                      id="ES__APP_SETTINGS__BTN_SAVE"
                      defaultMessage="Uložit"
                    />
                  )}
                </FormSubmitButton>
                <Box width={10} />
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  //    disabled={loading}
                  onClick={handleStartEditing}
                >
                  <FormattedMessage
                    id="ES__APP_SETTINGS__BTN_EDIT"
                    defaultMessage="Vložit soubory"
                  />
                </Button>
                <Box width={10} />
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
